import { Table, Text } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
}
const QuestionHeadCell = ({ label }: Props) => {
  return (
    <Table.HeadCell ellipsis>
      <Text.Normal ellipsis size="200" weight="semibold">
        {label}
      </Text.Normal>
    </Table.HeadCell>
  )
}
export default QuestionHeadCell
